import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const RightOfWay = {
  id: PropTypes.number,
  type: PropTypes.string,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const RightOfWayShape = PropTypes.shape(RightOfWay);
export const RightOfWayExact = PropTypes.exact(RightOfWay);
